<template>
  <div class="wrapper">
    <topnavbar :show="show" @toggle="toggle"></topnavbar>
    <div @click="toggleSidebar">
      <fade-transition :duration="200" origin="center top" mode="out-in">
        <router-view></router-view>
      </fade-transition>
    </div>
  </div>
</template>
<script>
  import { FadeTransition } from 'vue2-transitions';
  import topnavbar from '../views/Topnavbar';
  import router from "@/router";

  export default {
    components: {
      topnavbar,
      FadeTransition
    },
    data() {
      return {
        sidebarBackground: 'vue', //vue|blue|orange|green|red|primary,
        userName: this.$CURRENT_USER.getUserInfo('fullName', 'Guest'),
        profilePic: this.$CURRENT_USER.getProfilePicture(),
        show: false,
      };
    },
    methods: {
      toggleSidebar() {
        this.show = false;
      },
      toggle (value) {
        this.show = value;
      },
      logout() {
        router.push("/login");
      }
    }
  };
</script>
<style>
  body {
    background-color: rgba(243,244,246,1);
  }
  .page-content {
      min-height: calc(100vh - 200px);
  }
</style>
